import { createContext, useContext, useState, useEffect } from "react";
import { apiFetchAdmin } from '../../hooks/apiFetch';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useLangUrl } from '../../utilities/useLangUrl';

// import Cookies from 'js-cookie';

const AdminServiceContext = createContext();

export function AdminServiceProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [serviceData, setServiceData] = useState(null);
    const langUrl = useLangUrl();

    const navigate = useNavigate();

    useEffect(() => {
        if (!Cookies.get('adminToken')) {
            navigate("/admin/adminLogin")
        }

        async function fetchServices() {
            setLoading(true);
            try {
                const serviceData = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/orders/admins?${selectedStatus ? `status=${selectedStatus}&` : ""}${searchQuery ? "" : `page=${currentPage}&limit=10`}`);

                setServiceData(serviceData);
            } catch (err) {
                setServiceData(null);

            } finally {
                setLoading(false);
            }
        }
        fetchServices();
    }, [navigate, currentPage, searchQuery, selectedStatus, langUrl]);


    return (
        <AdminServiceContext.Provider
            value={{
                loading, setLoading, currentPage, setCurrentPage,
                searchQuery, setSearchQuery, selectedStatus, setSelectedStatus,
                serviceData, setServiceData
            }}>
            {children}
        </AdminServiceContext.Provider>
    );
}

export function useAdminService() {
    return useContext(AdminServiceContext);
}